import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../store'

export type MapShareState = {
  input: string
}

export const initialState: MapShareState = {
  input: ''
}

const mapShareSlice = createSlice({
  name: 'mapShare',
  initialState: initialState,
  reducers: {
    setInput: (state, action: PayloadAction<MapShareState['input']>) => {
      state.input = action.payload
    }
  }
})

const { setInput } = mapShareSlice.actions

export const useSetInput = () => {
  const dispatch = useDispatch()
  return (value: MapShareState['input']) => dispatch(setInput(value))
}

export const useInput = () => {
  return useSelector((state: RootState) => state.mapShare.input)
}

export default mapShareSlice.reducer
